import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store'
import {ActivatedRoute, Router} from '@angular/router'
import {map, take} from 'rxjs/operators'
import {rozpocznijSamoobsluge, zainicjalizujToken, zaladujStoreZSessionStorage} from './store/init.actions'
import {Observable, Subscription} from 'rxjs'
import {pobierzDaneZgloszenia} from '../shared/store/samoobsluga/samoobsluga.actions';
import {Samoobsluga} from '../shared/services/samoobsluga/types/samoobsluga';
import {pobierzStore} from '../shared/store/persistence/persist-store.actions';
import {InfoService} from '../shared/services/info/info.service';
import {aktualizujInfo} from '../shared/store/info/info.effect';

@Component({
  template: ''
})
export class InitComponent implements OnInit, OnDestroy {

  private readonly CORRELATION_ID_PARAMETR: string = 'correlationId'
  private readonly TOKEN_PARAMETR: string = 'token'
  private readonly INICJALNY_STAN_SAMOOBSLUGI_KOD = 'INC';
  private readonly ODLOZONY_STAN_SAMOOBSLUGI_KOD = 'ODL';

  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store,
    private router: Router,
    private route: ActivatedRoute,
    private infoService: InfoService
  ) {
    this.dodajWpisDoHistorii();
  }

  ngOnInit(): void {
    this.initAction();
  }

  private initAction(): void {
    this.subscriptions.push(this.infoService.pobierzInfo()
      .subscribe(info => {
        this.store.dispatch(aktualizujInfo(info))
      }))

    this.subscriptions.push(this.pobierzParametr(this.TOKEN_PARAMETR).subscribe((token) => {
      if (token !== '') {
        this.store.dispatch(zainicjalizujToken({token}))
      }
    }))

    this.subscriptions.push(this.pobierzParametr(this.CORRELATION_ID_PARAMETR).subscribe((correlationId) => {
      if (correlationId !== '') {
        this.store.dispatch(pobierzDaneZgloszenia({
          daneZgloszeniaZapytanie: {correlationId},
          nastepnaAkcja: (samoobsluga: Samoobsluga) => this.czyPrzejscNaStroneStartowa(samoobsluga) ? rozpocznijSamoobsluge({correlationId, samoobsluga}) : pobierzStore({correlationId})
        }))
      } else {
        this.store.dispatch(zaladujStoreZSessionStorage())
      }
    }))

  }

  private pobierzParametr(nazwaParametru: string): Observable<string> {
    return this.route.queryParamMap.pipe(
      take(1),
      map(paramMap => paramMap.get(nazwaParametru)),
      map(value => {
        if (value === null) {
          return ''
        }
        return value
      })
    )
  }

  private czyPrzejscNaStroneStartowa(samoobsluga: Samoobsluga): boolean {
    if (samoobsluga.stanSamoobslugi === undefined) throw new Error('Brak samoobsługi');
    return [
      this.INICJALNY_STAN_SAMOOBSLUGI_KOD,
      this.ODLOZONY_STAN_SAMOOBSLUGI_KOD
    ].includes(samoobsluga.stanSamoobslugi);
  }

  private czyInicjalnyStanSamoobslugi(samoobsluga: Samoobsluga): boolean {
    return [
      this.INICJALNY_STAN_SAMOOBSLUGI_KOD
    ].includes(samoobsluga.stanSamoobslugi);
  }

  // Hack polegający na wprowadzeniu dodatkowego wpisu w historii aby później zablokować możliwość przejścia wstecz na
  // zgloszenie.pzu.pl, ponieważ nie da się ze zgłoszenia wrócić na samoobsluge w przypadku gdy użytkownik kliknie wstecz
  // w przeglądarce, w NavigationService blokujemy przejście wstecz lecz gdy jest tylko jeden wpis w historii nie mamy
  // kontroli nad przejściem ( router angualrowy traci kontrole nad eventami ).
  private dodajWpisDoHistorii(): void {
    const navigationId = history.state.navigationId as number;
    history.pushState({navigationId: navigationId + 1}, '', this.router.url);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    })
  }

}
